var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44333 7.67667C3.4093 7.80935 3.2987 7.84145 3.20086 7.74729L1.25889 5.92403C1.15892 5.82987 1.18019 5.71217 1.30782 5.66082L4.03252 4.56515C4.16014 4.51379 4.23458 4.58227 4.20055 4.71495L3.44333 7.67667Z",
    fill: "url(#paint0_linear_3827_1901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83957 9.41005C1.73535 9.49993 1.63112 9.46355 1.60772 9.32659L1.07597 6.36273C1.05257 6.22791 1.11426 6.19367 1.21423 6.28783L3.0626 8.02334C3.16257 8.1175 3.16044 8.2673 3.05622 8.35718L1.83957 9.41005Z",
    fill: "url(#paint1_linear_3827_1901)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.06868 3.97452C4.15801 4.07938 4.12611 4.20563 4.00061 4.25699L1.2908 5.34624C1.16318 5.3976 1.09937 5.3334 1.14616 5.205L2.25859 2.1962C2.30538 2.0678 2.41812 2.0464 2.50745 2.15126L4.06868 3.97452Z",
    fill: "url(#paint2_linear_3827_1901)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23124 8.90502C1.25464 9.03983 1.21423 9.05695 1.13978 8.94139L0.0890388 7.30859C0.0145934 7.19304 0.0209744 7.009 0.101801 6.89772L0.57187 6.26429C0.652696 6.15515 0.739904 6.17441 0.765428 6.30923L1.23124 8.90502Z",
    fill: "url(#paint3_linear_3827_1901)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.89943 5.02096C0.852636 5.14936 0.77819 5.14936 0.733523 5.01882L0.374058 3.936C0.331518 3.80546 0.378312 3.62356 0.480409 3.53154L1.76087 2.36526C1.86297 2.27324 1.90551 2.3032 1.85871 2.4316L0.89943 5.02096Z",
    fill: "url(#paint4_linear_3827_1901)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.561235 5.43826C0.603775 5.5688 0.573997 5.76567 0.491044 5.87481L0.125198 6.37129C0.0443716 6.48043 -0.0109307 6.45903 0.00183135 6.32207L0.178373 4.60153C0.193262 4.46457 0.240057 4.46029 0.282597 4.59083L0.561235 5.43826Z",
    fill: "url(#paint5_linear_3827_1901)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00547 1.56491C2.05014 1.61841 2.00548 1.73611 1.90338 1.83026L1.32909 2.35456C1.22699 2.44658 1.2121 2.4316 1.29293 2.32246L1.77576 1.66977C1.85658 1.55849 1.96081 1.51141 2.00547 1.56491Z",
    fill: "url(#paint6_linear_3827_1901)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63841 10.7197C5.57035 10.8374 5.44911 10.8438 5.37253 10.7304L3.86661 8.52624C3.79004 8.41282 3.83683 8.30796 3.97296 8.29512L6.99757 7.98055C7.1337 7.96557 7.189 8.05117 7.11881 8.171L5.63841 10.7197Z",
    fill: "url(#paint7_linear_3827_1901)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00881 10.7219C5.08539 10.8353 5.04285 10.8909 4.91523 10.8481L2.07992 9.8787C1.95017 9.83376 1.9289 9.72463 2.03313 9.63475L3.24765 8.58188C3.35187 8.492 3.49864 8.51126 3.57734 8.62468L5.00881 10.7219Z",
    fill: "url(#paint8_linear_3827_1901)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06138 7.46909C7.15071 7.57395 7.11243 7.67025 6.9763 7.68523L3.90702 8.00409C3.77089 8.01907 3.68794 7.92063 3.72197 7.78795L4.48982 4.78129C4.52386 4.64861 4.62383 4.62507 4.71316 4.72779L7.06138 7.46909Z",
    fill: "url(#paint9_linear_3827_1901)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26496 10.0456C9.35429 10.1505 9.31814 10.2575 9.18413 10.2874L6.06168 10.9487C5.92768 10.9765 5.87451 10.9038 5.9447 10.7839L7.41659 8.25018C7.48465 8.13249 7.6144 8.11965 7.70374 8.2245L9.26496 10.0456Z",
    fill: "url(#paint10_linear_3827_1901)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24309 11.7362C4.12185 11.8004 3.94105 11.779 3.83896 11.6891L2.38834 10.4009C2.28624 10.3088 2.30751 10.2725 2.43726 10.3153L4.91735 11.1627C5.0471 11.2076 5.05348 11.2954 4.93437 11.3617L4.24309 11.7362Z",
    fill: "url(#paint11_linear_3827_1901)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61015 11.8582C7.5038 11.9459 7.31875 11.9652 7.19538 11.9031L6.18505 11.3852C6.06381 11.3232 6.07232 11.2483 6.20632 11.2205L8.89699 10.6512C9.03099 10.6234 9.05439 10.6705 8.94804 10.7582L7.61015 11.8582Z",
    fill: "url(#paint12_linear_3827_1901)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79399 11.9202C4.65786 11.9138 4.6451 11.856 4.76421 11.7897L5.3066 11.4965C5.42783 11.4323 5.62565 11.4302 5.74689 11.4922L6.53813 11.8967C6.65937 11.9588 6.64874 12.0058 6.51048 11.9994L4.79399 11.9202Z",
    fill: "url(#paint13_linear_3827_1901)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76906 10.632C9.81373 10.6855 9.75417 10.7818 9.63293 10.846L8.92039 11.229C8.79915 11.2932 8.78851 11.2761 8.89273 11.1884L9.49468 10.694C9.5989 10.6063 9.72227 10.5785 9.76906 10.632Z",
    fill: "url(#paint14_linear_3827_1901)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96536 7.43699C7.83774 7.48835 7.76329 7.41987 7.79732 7.28719L8.55454 4.32547C8.58857 4.19279 8.69918 4.16069 8.79914 4.25485L10.7411 6.07811C10.8411 6.17227 10.8198 6.28997 10.6922 6.34133L7.96536 7.43699Z",
    fill: "url(#paint15_linear_3827_1901)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.924 5.63942C10.9474 5.77423 10.8857 5.80847 10.7858 5.71431L8.9374 3.9788C8.83743 3.88464 8.83956 3.73484 8.94378 3.64496L10.1583 2.59209C10.2625 2.50222 10.3668 2.53859 10.3902 2.67555L10.924 5.63942Z",
    fill: "url(#paint16_linear_3827_1901)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73929 9.80594C9.69249 9.93434 9.57976 9.95574 9.49042 9.85088L7.9292 8.02763C7.83986 7.92277 7.87177 7.79651 7.99726 7.74515L10.7071 6.6559C10.8347 6.60454 10.8985 6.66874 10.8517 6.79714L9.73929 9.80594Z",
    fill: "url(#paint17_linear_3827_1901)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9088 4.69355C11.9833 4.80911 11.9769 4.99314 11.8961 5.10442L11.426 5.73571C11.3452 5.84485 11.258 5.82559 11.2324 5.69078L10.7666 3.09713C10.7432 2.96231 10.7836 2.94519 10.8581 3.06075L11.9088 4.69355Z",
    fill: "url(#paint18_linear_3827_1901)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6217 8.06829C11.6642 8.19882 11.6174 8.38072 11.5153 8.47274L10.2349 9.63903C10.1328 9.73104 10.0902 9.70109 10.137 9.57269L11.0963 6.98118C11.1431 6.85278 11.2176 6.85278 11.2622 6.98332L11.6217 8.06829Z",
    fill: "url(#paint19_linear_3827_1901)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8216 7.39847C11.8067 7.53543 11.7599 7.53971 11.7174 7.40917L11.4366 6.56174C11.3941 6.43121 11.426 6.23433 11.5068 6.12519L11.8748 5.62872C11.9556 5.51958 12.0109 5.54098 11.9982 5.67794L11.8216 7.39847Z",
    fill: "url(#paint20_linear_3827_1901)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2221 10.3324C10.1413 10.4437 10.0371 10.4886 9.99027 10.4372C9.94561 10.3837 9.99027 10.266 10.0924 10.1719L10.6688 9.64758C10.7709 9.55557 10.7858 9.57055 10.7049 9.67969L10.2221 10.3324Z",
    fill: "url(#paint21_linear_3827_1901)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13127 3.4759C8.20784 3.58932 8.16104 3.69418 8.02491 3.70702L5.00031 4.0216C4.86418 4.03658 4.80887 3.95098 4.87907 3.83114L6.35947 1.28243C6.42753 1.16473 6.54877 1.15831 6.62534 1.27173L8.13127 3.4759Z",
    fill: "url(#paint22_linear_3827_1901)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75022 3.42026C8.646 3.51014 8.49924 3.49088 8.42054 3.37746L6.98906 1.28029C6.91249 1.16687 6.95503 1.11123 7.08265 1.15403L9.91795 2.12344C10.0477 2.16838 10.069 2.27752 9.96475 2.3674L8.75022 3.42026Z",
    fill: "url(#paint23_linear_3827_1901)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50805 7.22086C7.47402 7.35354 7.37405 7.37708 7.28471 7.27436L4.93862 4.53305C4.84929 4.42819 4.88757 4.33189 5.0237 4.31691L8.09298 3.99806C8.22911 3.98308 8.31206 4.08152 8.27803 4.21419L7.50805 7.22086Z",
    fill: "url(#paint24_linear_3827_1901)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58128 3.7541C4.51322 3.8718 4.38347 3.88464 4.29414 3.77978L2.73291 1.95652C2.64358 1.85166 2.67974 1.74466 2.81374 1.7147L5.93619 1.05345C6.07019 1.02563 6.12337 1.09839 6.05318 1.21823L4.58128 3.7541Z",
    fill: "url(#paint25_linear_3827_1901)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08052 0.839456C6.95077 0.794516 6.94439 0.706777 7.06351 0.640438L7.75478 0.268083C7.87602 0.203884 8.05682 0.225284 8.16104 0.315162L9.60954 1.60343C9.71163 1.69545 9.69036 1.73182 9.56062 1.68903L7.08052 0.839456Z",
    fill: "url(#paint26_linear_3827_1901)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10089 1.35091C2.96688 1.37873 2.94349 1.33165 3.04984 1.24391L4.3856 0.143965C4.49195 0.0562257 4.677 0.0369659 4.80037 0.0990252L5.81282 0.616899C5.93406 0.678958 5.92555 0.753857 5.79155 0.781677L3.10089 1.35091Z",
    fill: "url(#paint27_linear_3827_1901)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69341 0.50348C6.57217 0.567679 6.37435 0.569819 6.25312 0.50776L5.46187 0.103305C5.34063 0.0412459 5.35126 -0.00583352 5.48952 0.000586395L7.20601 0.0797654C7.34214 0.0861853 7.35491 0.143965 7.23579 0.210304L6.69341 0.50348Z",
    fill: "url(#paint28_linear_3827_1901)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50532 1.30811C2.39897 1.39585 2.27561 1.42367 2.23094 1.37017C2.18627 1.31667 2.24583 1.22037 2.36707 1.15617L3.07962 0.773117C3.20086 0.708917 3.21149 0.726037 3.10727 0.813776L2.50532 1.30811Z",
    fill: "url(#paint29_linear_3827_1901)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59071 10.0178C1.64388 9.97286 1.76087 10.0178 1.85446 10.1205L2.37557 10.7005C2.46704 10.8032 2.45215 10.8182 2.34367 10.7368L1.6928 10.2511C1.58433 10.1697 1.53753 10.0649 1.59071 10.0178Z",
    fill: "url(#paint30_linear_3827_1901)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6007 2.20904C10.6539 2.1641 10.7496 2.22402 10.8134 2.346L11.1942 3.06289C11.258 3.18487 11.241 3.19557 11.1537 3.09071L10.6624 2.4851C10.5773 2.38024 10.5497 2.25398 10.6007 2.20904Z",
    fill: "url(#paint31_linear_3827_1901)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3051 1.75108C10.4157 1.8324 10.4603 1.93726 10.4093 1.98434C10.3561 2.02928 10.2391 1.98434 10.1455 1.88162L9.62442 1.30169C9.53296 1.19897 9.54785 1.18399 9.65633 1.26531L10.3051 1.75108Z",
    fill: "url(#paint32_linear_3827_1901)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33547 9.51705C1.42267 9.62405 1.45033 9.74817 1.39715 9.79311C1.34397 9.83804 1.24826 9.77813 1.18445 9.65615L0.803714 8.93926C0.739904 8.81728 0.75692 8.80658 0.844128 8.91144L1.33547 9.51705Z",
    fill: "url(#paint33_linear_3827_1901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3827_1901",
    x1: 6,
    y1: 5.29942e-10,
    x2: 6.01196,
    y2: 14.6172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA88DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373617,
    stopColor: "#5E75E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80C6EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbs);
export default __webpack_public_path__ + "static/media/orbs.0f1186d9548085158bfc9ddc129dd972.svg";
export { ForwardRef as ReactComponent };